import {UseSocketOptions} from 'socket.io-react-hook/lib/cjs/types';

import {SocketNamespace} from 'enums';

import {useNamespaceSocket} from './namespace-socket';

export const useClientSocket = <T>(jwt: string, options: UseSocketOptions<T>) =>
    useNamespaceSocket(SocketNamespace.Clients, {
        ...options,
        enabled: !!jwt && options.enabled,
        auth: {
            token: jwt
        }
    });